exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lifmGNSoimxSIN{padding:8px;background:#fff;border-radius:3px}._1OYaD5X4bOFzHP{background:#fdfae5;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:16px 26px;text-align:center}._1OYaD5X4bOFzHP h3{margin-top:12px}._1OYaD5X4bOFzHP p{margin-top:6px;margin-bottom:16px}._2r0TugWKrjdprP{margin-top:6px;background:#f2d600;padding:2px 4px;border-radius:3px;font-size:11px}._2GUkxuwG8-jCEf{padding:16px 16px 0}._1NTgUUWh46GWue{display:flex;align-items:center;justify-content:space-between;margin-top:-10px;height:40px}._1NTgUUWh46GWue h3{color:#6c547b}._1NTgUUWh46GWue img{transform:rotate(10deg)}._1k-y-i8bm9Rl7F{display:flex;align-items:baseline;margin-bottom:10px}.tV0YibQqlji1H7{margin-bottom:18px}._239mqRKuaByA6p{width:6px;height:6px;background-color:#0079bf;border-radius:50%;margin-right:6px;position:relative;top:-2px}._2mVouPFPjhrU6J{height:32px;padding:0}.-JasI9K5v4uv56{mix-blend-mode:hard-light}", ""]);

// exports
exports.locals = {
	"upsellOverlay": "lifmGNSoimxSIN",
	"upsellOverlayHeader": "_1OYaD5X4bOFzHP",
	"upsellOverlayTag": "_2r0TugWKrjdprP",
	"upsellOverlayBody": "_2GUkxuwG8-jCEf",
	"upsellOverlayBodyHeader": "_1NTgUUWh46GWue",
	"upsellOverlayThing": "_1k-y-i8bm9Rl7F",
	"upsellOverlayThings": "tV0YibQqlji1H7",
	"upsellOverlayThingBullet": "_239mqRKuaByA6p",
	"button": "_2mVouPFPjhrU6J",
	"spinner": "-JasI9K5v4uv56"
};